module.exports = __webpack_public_path__ + "static/media/3.723d5d2e.svg";